import { createRoutine } from 'redux-saga-routines';
import { DocumentType } from '@modules/documents/types/document-type';
import { createAction } from '@reduxjs/toolkit';

export const documentUploadRoutine = createRoutine('DOCUMENTS/UPLOAD');

export const getFormFieldsRoutine = createRoutine<DocumentType>('DOCUMENTS/GET_FORM_FIELDS');

export const setFileNameAction = createAction<string>('DOCUMENTS/SET_FILE_NAME');
